const LOGIN_PATH = "/login";

export function isCancelledError(error) {
  return (
    error?.name === "CanceledError" ||
    error?.code === "ERR_CANCELED" ||
    error?.isCancelled
  );
}

export function isOfflineError(error) {
  return (
    !navigator.onLine ||
    error?.message === "Network Error" ||
    error?.code === "ERR_NETWORK"
  );
}

export function isTimeoutError(error) {
  return error?.code === "ECONNABORTED";
}

export function isUnauthorizedError(error) {
  return error?.response?.status === 401;
}

export function isForbiddenError(error) {
  return error?.response?.status === 403;
}

export function isServerError(error) {
  return (error?.response?.status ?? 0) >= 500;
}

export function redirectToLogin(setToken) {
  setToken("");
  window.location.href = LOGIN_PATH;
}
